"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
// eslint-disable-next-line import/no-cycle
const assets_1 = require("~/assets");
const isEmail_1 = __importDefault(require("~/utils/isEmail"));
const clampNumberInput_1 = __importStar(require("~/utils/clampNumberInput"));
const usePreventMouseUpWhileSelecting_1 = __importDefault(require("~/hooks/usePreventMouseUpWhileSelecting"));
const utils_1 = require("~/utils/utils");
const Input_module_scss_1 = __importDefault(require("./Input.module.scss"));
// eslint-disable-next-line react/display-name
const Input = (0, react_1.forwardRef)((_a, ref) => {
    var { type = 'text', value: defaultValue = type === 'number' ? '0' : '', placeholder = '', required = false, maxLength = Infinity, minLength = 0, validator, max = Infinity, min = -Infinity, arrows = true, precision = 1, lengthInput = false, step = 1, hideErrorOnFocus = true, customErrors = {}, onChange = () => {
        /* do nothing */
    }, onInput = () => {
        /* do nothing */
    }, onBlur = () => {
        /* do nothing */
    }, className = '', defaultKey = false, disabled = false } = _a, props = __rest(_a, ["type", "value", "placeholder", "required", "maxLength", "minLength", "validator", "max", "min", "arrows", "precision", "lengthInput", "step", "hideErrorOnFocus", "customErrors", "onChange", "onInput", "onBlur", "className", "defaultKey", "disabled"]);
    const { t } = (0, react_i18next_1.useTranslation)('input');
    const inputRef = (0, react_1.useRef)(null);
    const preventMouseUpEventWhileSelecting = (0, usePreventMouseUpWhileSelecting_1.default)(inputRef);
    const [error, setError] = (0, react_1.useState)(null);
    const [highlighted, setHighlighted] = (0, react_1.useState)(false);
    const [isPasswordVisible, setPasswordVisible] = (0, react_1.useState)(false);
    const [isClearNeeded, setClearNeeded] = (0, react_1.useState)(() => (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) > 0);
    const [validateOnType, setValidateOnType] = (0, react_1.useState)(false);
    const isPasswordInput = type === 'password';
    const isDateInput = type === 'date';
    const passwordErrorClassName = isPasswordInput ? ` ${Input_module_scss_1.default['password-error']}` : '';
    const errorIconClassName = isDateInput ? Input_module_scss_1.default['error_build-in'] : `${Input_module_scss_1.default.error}${passwordErrorClassName}`;
    const validate = (value) => {
        // eslint-disable-next-line no-shadow
        let validateFn = () => null;
        if (validator) {
            validateFn = validator;
        }
        if (!validator) {
            if (type === 'email') {
                // eslint-disable-next-line react/display-name, react/function-component-definition
                validateFn = (emailString) => { var _a; return (0, isEmail_1.default)(emailString) ? null : (_a = customErrors.invalid) !== null && _a !== void 0 ? _a : t('email.invalid'); };
            }
            else if (minLength !== 0 || (isPasswordInput && maxLength !== Infinity)) {
                // eslint-disable-next-line react/display-name
                validateFn = function (stringValue) {
                    var _a, _b;
                    const trimmedLength = stringValue.trim().length;
                    if (minLength !== 0 && trimmedLength < minLength) {
                        return (_a = customErrors['min-value']) !== null && _a !== void 0 ? _a : t('min-value');
                    }
                    if (isPasswordInput && maxLength !== Infinity && trimmedLength > maxLength) {
                        return (_b = customErrors['max-value']) !== null && _b !== void 0 ? _b : t('max-value');
                    }
                    return null;
                };
            }
        }
        return validateFn(value);
    };
    const inputHandler = (event) => {
        var _a;
        const { value } = event.target;
        let localError = null;
        setClearNeeded(value.length > 0);
        setHighlighted(false);
        if (required && !value) {
            localError = (_a = customErrors.required) !== null && _a !== void 0 ? _a : t('required');
            setError(localError);
        }
        else {
            setError(null);
        }
        if (validateOnType) {
            localError = validate(value);
            setError(localError);
        }
        if (lengthInput && type === 'number') {
            const normalized = (0, clampNumberInput_1.getLengthInputValue)(value, min, max, precision);
            const input = event.target;
            if (input.value !== normalized.draft) {
                input.value = normalized.draft;
            }
            onInput(normalized.value, localError);
            return;
        }
        onInput(value, localError);
    };
    const numberInputHandler = (value) => {
        const boundedValue = (0, clampNumberInput_1.default)(value, min, max);
        if (lengthInput) {
            if (inputRef.current) {
                inputRef.current.value = boundedValue;
            }
            onChange(boundedValue, error);
            return boundedValue;
        }
        if (boundedValue !== value) {
            if (inputRef.current) {
                inputRef.current.value = boundedValue;
            }
            return boundedValue;
        }
        onChange(value, error);
        return value;
    };
    const changeHandler = (event) => {
        var _a;
        const { value } = event.target;
        let localError = null;
        if (lengthInput && type === 'number') {
            const boundedValue = (0, clampNumberInput_1.default)(value, min, max);
            const input = event.target;
            input.value = boundedValue;
            return onChange(boundedValue, error);
        }
        setClearNeeded(value.length > 0);
        if (required && !value) {
            localError = (_a = customErrors.required) !== null && _a !== void 0 ? _a : t('required');
            onChange(value, localError);
            return setError(localError);
        }
        localError = validate(value);
        if (localError) {
            setValidateOnType(Boolean(localError));
            onChange(value, localError);
            return setError(localError);
        }
        if (type === 'number') {
            numberInputHandler(value);
        }
        return onChange(value, error);
    };
    // change event fires on blur only if value has changed
    const blurHandler = (event) => {
        const { value } = event.target;
        onBlur(value, error);
        changeHandler(event);
    };
    const focusHandler = () => {
        if (hideErrorOnFocus) {
            setError(null);
        }
    };
    const focus = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
        // puts cursor at the end of entered value
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
        }, 0);
    };
    // type === 'search'
    const clearHandler = () => {
        if (inputRef.current) {
            inputRef.current.value = '';
        }
        onChange('', null);
        onInput('', null);
        setClearNeeded(false);
        focus();
    };
    // type === 'password'
    const changePasswordVisibleHandler = () => {
        setPasswordVisible((current) => !current);
        focus();
    };
    // type === 'number'
    const increaseValue = () => {
        if (inputRef.current) {
            const newValue = (0, utils_1.normalizeValueToStep)(Number(inputRef.current.value) + step, step, precision).toString();
            inputRef.current.value = newValue;
            numberInputHandler(newValue);
        }
    };
    const decreaseValue = () => {
        if (inputRef.current) {
            const newValue = (0, utils_1.normalizeValueToStep)(Number(inputRef.current.value) - step, step, precision).toString();
            inputRef.current.value = newValue;
            numberInputHandler(newValue);
        }
    };
    (0, react_1.useEffect)(() => {
        const input = inputRef.current;
        input === null || input === void 0 ? void 0 : input.addEventListener('input', inputHandler);
        input === null || input === void 0 ? void 0 : input.addEventListener('change', changeHandler);
        input === null || input === void 0 ? void 0 : input.addEventListener('focus', focusHandler);
        input === null || input === void 0 ? void 0 : input.addEventListener('blur', blurHandler);
        return () => {
            input === null || input === void 0 ? void 0 : input.removeEventListener('input', inputHandler);
            input === null || input === void 0 ? void 0 : input.removeEventListener('change', changeHandler);
            input === null || input === void 0 ? void 0 : input.removeEventListener('focus', focusHandler);
            input === null || input === void 0 ? void 0 : input.removeEventListener('blur', blurHandler);
        };
    });
    (0, react_1.useEffect)(() => {
        if (lengthInput && inputRef.current && document.activeElement !== inputRef.current) {
            inputRef.current.value = String(defaultValue);
        }
    }, [defaultValue, lengthInput]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        highlight: () => {
            setHighlighted(true);
        },
        /**
         * Force input to show an error
         * @param inputError Error type to show
         * @param errorMessage Show custom error message (eg. ref.current.showError(null, 'my custom error'))
         */
        // eslint-disable-next-line no-shadow
        showError: (inputError, errorMessage) => {
            if (inputError) {
                setError(t(`${type === 'email' ? 'email.' : ''}${inputError}`));
            }
            else if (errorMessage) {
                setError(errorMessage);
            }
            else {
                setError(null);
            }
        },
        setValue: (value) => {
            if (inputRef.current) {
                inputRef.current.value = value;
            }
        },
    }));
    let optionalProps = {};
    if (defaultKey) {
        optionalProps = { key: defaultValue };
    }
    return (react_1.default.createElement("div", { className: `${Input_module_scss_1.default.container} ${className}`, "data-invalid": Boolean(error) || highlighted },
        react_1.default.createElement("input", Object.assign({ className: Input_module_scss_1.default.input, ref: inputRef, defaultValue: defaultValue, type: type === 'password' && isPasswordVisible ? 'text' : type, maxLength: maxLength, minLength: minLength, placeholder: placeholder, required: required, max: type === 'number' ? max : '', min: type === 'number' ? min : '', onMouseDown: preventMouseUpEventWhileSelecting, onKeyDown: (event) => {
                if (lengthInput && event.key === 'Enter') {
                    changeHandler(event.nativeEvent);
                }
            }, disabled: disabled }, optionalProps, props)),
        react_1.default.createElement("div", { className: Input_module_scss_1.default.controls },
            type === 'search' ? (react_1.default.createElement(react_1.default.Fragment, null,
                isClearNeeded ? react_1.default.createElement("img", { src: assets_1.svgSystemClose, onClick: clearHandler, alt: "" }) : null,
                react_1.default.createElement("img", { className: Input_module_scss_1.default.search, src: assets_1.svgBasicSearch, alt: "" }))) : null,
            isPasswordInput ? (react_1.default.createElement("img", { className: Input_module_scss_1.default.password, src: isPasswordVisible ? assets_1.svgBasicHideIcon : assets_1.svgBasicShowIcon, onMouseDown: (event) => event.preventDefault(), onClick: changePasswordVisibleHandler, alt: "" })) : null,
            type === 'number' && arrows ? (react_1.default.createElement("div", { className: Input_module_scss_1.default.arrows },
                react_1.default.createElement("img", { src: assets_1.svgSystemChevronUp, onClick: increaseValue, alt: "" }),
                react_1.default.createElement("img", { src: assets_1.svgSystemChevronDown, onClick: decreaseValue, alt: "" }))) : null),
        error ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("img", { className: errorIconClassName, src: assets_1.svgSystemError, alt: "" }),
            react_1.default.createElement("div", { className: Input_module_scss_1.default['error-message'] }, error))) : null));
});
exports.default = Input;
